import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { LocalStorageVariablesKeys } from '../../../core/enums/local-storage-variables.meta';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { OnboardingFacade } from '../../../facade/onboarding-facade';

export const AuthGuard: CanActivateFn = (): Observable<boolean | UrlTree> | boolean => {
    const onboardingFacade = inject(OnboardingFacade);
    const router = inject(Router);
    const accessToken = onboardingFacade.getItemFromLocalStorage(LocalStorageVariablesKeys.ACCESS_TOKEN);
    if (accessToken) {
        return true;
    }
    return onboardingFacade.clearSessionAndOptionallyRedirect$('').pipe(
        map(() => {
            const pathName = window.location.pathname;
            if (!['/'].includes(pathName)) {
                return router.createUrlTree(['/auth/login'], { queryParams: { ['back-url']: pathName } });
            } else {
                return router.createUrlTree(['/auth/login']);
            }
        }),
    );
};
